import {
  en_apacTranslations,
  en_defaultTranslations,
  en_hsbcSgTranslations,
  enGB_defaultTranslations,
  enGB_hsbcSgTranslations,
  enGB_apacTranslations,
  ar_defaultTranslations,
  ar_bootstrapTranslations,
  ar_apacTranslations,
  ar_hsbcSgTranslations,
  ar_hsbcQaTranslations,
  en_hsbcQaTranslations,
} from "@hopper-b2b/i18n";
import { TranslationLanguage } from "@hopper-b2b/types";
import { merge } from "lodash-es";

/** Some configurations don't need a review from translations team
 * If you want to override any of them, add them as an attribute in this object
 */
const enGBTranslations = merge(
  enGB_defaultTranslations,
  enGB_apacTranslations,
  enGB_hsbcSgTranslations,
  en_hsbcQaTranslations
);

const arTranslations = merge(
  ar_defaultTranslations,
  ar_bootstrapTranslations,
  ar_apacTranslations,
  ar_hsbcSgTranslations,
  ar_hsbcQaTranslations
);

const translation = {
  [TranslationLanguage.en]: merge(
    en_defaultTranslations,
    en_apacTranslations,
    en_hsbcSgTranslations,
    en_hsbcQaTranslations
  ),
  [TranslationLanguage["en-GB"]]: enGBTranslations,
  [TranslationLanguage["ar"]]: arTranslations,
};

export default translation;
